import React from 'react';
import { PdfType } from '../utils/Types';
import '../assets/style/PdfPreviewCard.css';
import CloseIcon from '@mui/icons-material/Close';
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formattedDateWithFormat } from '../utils/Util';

interface IPdfPreviewCardType {
  pdf: PdfType;
  handleRemove: (id: number | string) => void;
}

const PdfPreviewCard: React.FC<IPdfPreviewCardType> = ({
  pdf,
  handleRemove,
}) => {
  return (
    <div className="border rounded pdf-card p-3">
      <CloseIcon
        className="pdf-remove-icon"
        onClick={() => handleRemove(pdf.id)}
      />
      <div className="file-preview-container me-2">
        <div className="pdf-logo">
          <a href={pdf.url} target="_blank" rel="noreferrer">
            <Image src={pdf.thumnailUrl} width={86} height={92} />
          </a>
        </div>
      </div>
      <div className="file-details-container flex-grow-1">
        <div className="d-flex justify-content-between align-items-center pe-3">
          <p className="file-name mb-0">
            <OverlayTrigger
              placement="top-start"
              overlay={<Tooltip id={`id${pdf.id}`}>{pdf.name}</Tooltip>}
            >
              <span>{pdf.name}</span>
            </OverlayTrigger>
          </p>
        </div>
        <p className="file-size mb-0">
          Uploaded on:{' '}
          {formattedDateWithFormat(pdf.createdOn, 'DD-MM-YYYY hh:mm A')}
        </p>
        <p className="file-size mb-0">Order: {pdf?.order}</p>
      </div>
    </div>
  );
};

export default PdfPreviewCard;
